import { Paper, Box, Typography, Divider } from '@mui/material';

export const WindFarmCard = (props: any) => {
  if (!props.data || props.data.length === 0) {
    return <></>;
  }
  return (
    <Paper sx={{ 
      minHeight: '240px',
      borderRadius: '16px',
      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
      border: '1px solid rgba(229, 231, 235, 0.8)',
      background: 'linear-gradient(145deg, #ffffff 0%, #fafafa 100%)',
    }}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography
          sx={{
            m: '24px',
            color: '#17052D',
            fontSize: '16px',
            fontWeight: 500,
          }}
        >
          Wind Farm Info
        </Typography>
        <Divider sx={{ color: '#F7F8FA' }} />
        <Box sx={{ display: 'flex', m: '24px', gap: '50px' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
            <Typography
              sx={{ color: '#45009C', fontSize: '14px', opacity: 0.8 }}
            >
              {props.data[0].site_display_name}
            </Typography>
            <Typography
              sx={{ color: '#17052D', fontSize: '14px', opacity: 0.8 }}
            >
              {props.data[0].type}
            </Typography>
            <Typography
              sx={{ color: '#17052D', fontSize: '14px', opacity: 0.8 }}
            >
              {props.data[0].location}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
            <Typography
              sx={{ color: '#17052D', fontSize: '14px', opacity: 0.8 }}
            >
              Units Monitored
            </Typography>
            <Typography
              sx={{ color: '#17052D', fontSize: '14px', fontWeight: 600 }}
            >
              {props.data[0].units}
            </Typography>
            {/* <Typography sx={{ color: '#17052D', fontSize: '14px' }}>
              Hub Height
            </Typography>
            <Typography
              sx={{ color: '#17052D', fontSize: '14px', fontWeight: 600 }}
            >
              101 m (331 ft)
            </Typography> */}
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
            <Typography
              sx={{ color: '#17052D', fontSize: '14px', opacity: 0.8 }}
            >
              Cameras
            </Typography>
            <Typography
              sx={{ color: '#17052D', fontSize: '14px', fontWeight: 600 }}
            >
              {props.data[0].cameras}
            </Typography>
            {/* <Typography sx={{ color: '#17052D', fontSize: '14px' }}>
              Rated Wind Speed
            </Typography>
            <Typography
              sx={{ color: '#17052D', fontSize: '14px', fontWeight: 600 }}
            >
              10.1 m/s (36 km/h)
            </Typography> */}
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};
